<template>
    <div
        :class="$style.seo_only"
        :aria-hidden="props.ariaHidden"
    >
        <slot />
    </div>
</template>
<script lang="ts" setup>
interface OnlySeoProps {
    ariaHidden?: boolean
}

const props = defineProps<OnlySeoProps>()
</script>
<style module>
.seo_only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}
</style>
